import Button from '@cohort/merchants/components/buttons/Button';
import ErrorPageTemplate from '@cohort/merchants/components/error-pages/ErrorPageTemplate';
import {getHomeRoute} from '@cohort/merchants/lib/Pages';
import {WarningOctagon} from '@phosphor-icons/react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const {t} = useTranslation('components', {keyPrefix: 'errorPages.notFoundPage'});

  return (
    <ErrorPageTemplate
      title={t('title')}
      description={t('description')}
      Icon={WarningOctagon}
      cta={
        <Button className="w-full" onClick={() => navigate(getHomeRoute().path)}>
          {t('btnBackHome')}
        </Button>
      }
    />
  );
};

export default NotFoundPage;
